import React, { useId, useMemo } from "react";
import { FieldError, Message } from "react-hook-form";

export type ErrorsBlockProps = {
    className?: string
    errorMessages?: Message | Message[] | FieldError[]
};

const ErrorsBlock: React.FC<ErrorsBlockProps> = ({
    className,
    errorMessages
}: ErrorsBlockProps) => {
    const id = useId();

    const errors = useMemo<Message[] | undefined>(() => {
        if (!errorMessages)
            return undefined;
        if (!Array.isArray(errorMessages)) {
            return [errorMessages];
        }
        const parsedErrors: Message[] = [];
        errorMessages.forEach((error) => {
            if(typeof error === 'object'){
                parsedErrors.push(error.message as string);
            }
        });
        return parsedErrors.length ? parsedErrors : errorMessages;
    }, [errorMessages]);

    return (
        <>
            {
                errors
                && errors?.map(error =>
                    <small
                        key={id + error}
                        className={className}>{error}
                    </small>
                )
            }
        </>
    );
};

export default ErrorsBlock;
